import { render, staticRenderFns } from "./MainSnackbar.vue?vue&type=template&id=76babcab"
import script from "./MainSnackbar.vue?vue&type=script&lang=ts"
export * from "./MainSnackbar.vue?vue&type=script&lang=ts"
import style0 from "./MainSnackbar.vue?vue&type=style&index=0&id=76babcab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
